import type { JSX } from "react";
import { variantStyles, colorStyles, text } from "./Text.css";

const variantElements = {
  hero: "h1",
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  "subheader-large": "h4",
  subheader: "h5",
  "subheader-small": "h6",
  "label-large": "span",
  label: "span",
  "label-small": "span",
  body: "p",
  "body-small": "p",
} as const satisfies Record<
  keyof typeof variantStyles,
  "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "span" | "p"
>;

export const colors = Object.keys(colorStyles);
export const variants = Object.keys(variantStyles);

interface ForwardedProps {
  id?: string;
  "data-cy"?: string;
}

interface TextProps extends ForwardedProps {
  variant?: keyof typeof variantElements;
  // Overrides the variant's element, e.g. to keep the heading level right.
  as?: keyof JSX.IntrinsicElements;
  children: string;
  uppercase?: boolean;
  color?: keyof typeof colorStyles;
}

const Text = ({
  variant = "body",
  as,
  children,
  color = "neutral-0",
  uppercase = false,
  ...forwardedProps
}: TextProps) => {
  const Tag = as ?? variantElements[variant];

  return (
    <Tag
      {...forwardedProps}
      className={text({ color: color, font: variant, uppercase: uppercase })}
    >
      {children}
    </Tag>
  );
};

export default Text;
